module.exports = __webpack_public_path__ + "img/Sales Team Administration.219eb474.png";